/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')

const Table = require('../../../client/clientjs/components/Table')

class RankingTable extends React.Component {
  constructor(props) {
    super(props)

    const { ranking, teamCatches, round, contestSeoName } = props
    const { keepOnlyTop } = round.settings || {}

    const teams = ranking
      .sort((a, b) => (a.score || 0) - (b.score || 0))
      .map(rank => ({
        ...rank,
        fishCatches: teamCatches[rank.teamId] || [],
        round,
      }))

    const columns = [
      {
        name: 'teamName',
        display: 'Team',
        getCellValue: row => (
          <span>
            {row.teamName}&nbsp;
            <a href={`/contests/${contestSeoName}/teams/${row.teamId}`} target="_blank">
              <i className="fas fa-external-link" style={{ fontSize: '0.8em' }} />
            </a>
          </span>
        ),
        getCellRawValue: row => (row.teamName || '').toLowerCase(),
        getCellSubRowValue: (row, subRow) => {
          const fc = subRow
          return (
            <article className="media">
              <figure className="media-left">
                <p className="image is-64x64">
                  <a href={`/users/${fc.createdBy}/catches/${fc.id}`} target="_blank">
                    {fc.medias && fc.medias.length > 0 && (
                      <img
                        src={fc.medias[0].url_100}
                        height="50"
                        alt="fish catch"
                        className="has-object-fit-contain"
                        style={{ maxHeight: '100%' }}
                      />
                    )}
                  </a>
                </p>
              </figure>
              <div className="media-content">
                <div className="content is-size-7-tablet is-size-8-mobile">
                  {fc.speciesCustomName ||
                    (fc.fish && fc.fish.names && fc.fish.names.length ? fc.fish.names[0].value : '')}
                  <br />
                  {fc.size ? `${fc.size}cm` : ''}
                </div>
              </div>
            </article>
          )
        },
        isSortable: true,
      },
      {
        name: 'score',
        display: '(round score)',
        getCellValue: row => row.score || 0,
        getCellSubRowValue: (row, subRow, subRowIdx) =>
          !keepOnlyTop || subRowIdx < keepOnlyTop ? subRow.contestAsso.score : `(${subRow.contestAsso.score})`,
        isSortable: true,
        isTextCentered: true,
        isSubRowTextCentered: true,
      },
      {
        name: 'points',
        display: 'Round Points',
        getCellValue: row => row.points || 0,
        isSortable: true,
        isBold: true,
        isTextCentered: true,
      },
    ]

    const hasSomeSimpleId = teams.some(elt => !!elt.teamSimpleId)
    if (hasSomeSimpleId) {
      columns.unshift({
        name: 'teamSimpleId',
        display: '',
        getCellValue: row => row.teamSimpleId,
      })
    }

    this.state = {
      rows: teams,
      columns,
    }

    this.onRowClick = this.onRowClick.bind(this)
  }

  onRowClick(row) {
    const { rows } = this.state

    const rowRankingIndex = rows.findIndex(elt => elt.teamId === row.teamId)

    if (rowRankingIndex === -1) {
      return
    }

    const rowRanking = rows[rowRankingIndex]

    rows[rowRankingIndex] = {
      ...rowRanking,
      isDisplayed: !rowRanking.isDisplayed,
    }

    this.setState({
      rows,
    })
  }

  render() {
    const { rows, columns } = this.state
    return (
      <Table
        rows={rows}
        columns={columns}
        getRowKey={row => row.teamId}
        onRowClick={this.onRowClick}
        getSubRows={row => (row.isDisplayed ? row.fishCatches || [] : [])}
        getSubRowKey={(row, subRow) => row.teamId + subRow.id}
        defaultSortBy="points"
        defaultSortASC={false}
        isFullWidth
        tableClass="is-size-7 is-size-8-mobile"
      />
    )
  }
}

RankingTable.propTypes = {
  ranking: PropTypes.array,
  contestSeoName: PropTypes.string.isRequired,
  teamCatches: PropTypes.object,
  round: PropTypes.object.isRequired,
}

RankingTable.defaultProps = {
  ranking: [],
  teamCatches: {},
}

module.exports = RankingTable
